export interface IBreakpoints {
  pc: string;
}

export const breakpoints: IBreakpoints = {
  pc: '768px'
};
